/**
 * Scroll to top button functionality
 */
function scrollToTopButton() {
  const scrollToTopButton = document.getElementById("scrollToTopButton");
  if (!scrollToTopButton) return;

  scrollToTopButton.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  scrollToTopButton();
});
